const SET_DATA = 'SET_DATA';
const SET_ALL_DATA = 'SET_ALL_DATA';
const SET_SCOREBOARD = 'SET_SCOREBOARD';
const CONCAT_DATA = 'CONCAT_DATA';
const UPDATE_DATA = 'UPDATE_DATA';
const SET_DETAIL = 'SET_DETAIL';
const SET_SELECTED_DATA = 'SET_SELECTED_DATA';
const ADD_TO_SELECTED = 'ADD_TO_SELECTED';
const REMOVE_FROM_SELECTED = 'REMOVE_FROM_SELECTED';

const state = {
	privateOrders: [],
	allPrivateOrders: [],
	orderDetail: null,
	scoreboard: {
		submission_count: 0,
		closing_count: 0,
		shipping_pending: 0,
		shipping_processed: 0,
		shipping_delivery: 0,
		shipping_completed: 0,
		shipping_cancelled: 0,
		shipping_return_to_shipper: 0,
		shipping_refunded: 0,
		shipping_process_return: 0,
		shipping_return_completed: 0,
		shipping_return_broken: 0,
		quantity: 0,
	},
	selectedData: [],
};

const getters = {
	privateOrders: state => state.privateOrders,
	allPrivateOrders: state => state.allPrivateOrders,
	scoreboard: state => state.scoreboard,
	orderDetail: state => state.orderDetail,
	selectedData: state => state.selectedData,
};

const mutations = {
	[SET_DATA](state, payload) {
		state.privateOrders = payload;
	},
	[SET_SCOREBOARD](state, payload) {
		state.scoreboard = payload;
	},
	[CONCAT_DATA](state, payload) {
		state.privateOrders = state.privateOrders.concat(payload);
	},
	[UPDATE_DATA](state, payload) {
		const id = payload.id;
		const order = state.privateOrders.find(order => (order?.action || order?._id) === id);

		if (order) {
			if (order.shipping.receipt_number) {
				order.shipping = {
					...order.shipping,
					receipt_number: '',
				};
			}
			order.customer_data = payload.customer_data;
			order.product_data = payload.product_data;
			order.product_data.product_price = payload.product_price;
			order.quantity = payload.customer_data.quantity;
			order.status = payload.status ?? order.status;
			order.product_data.other_cost = payload.other_cost;
			order.product_data.shipping_cost = payload.shipping_cost;
			order.total_price = payload.total_price;
			order.shipping.receipt_number = payload?.shipping?.receipt_number ?? (order?.shipping?.receipt_number ?? '-');
			order.shipping = payload.shipping;
			order.payment_type = payload?.payment?.type || 'full_payment';
			order.processing_at = payload.processing_at;
			order.other_cost = payload?.other_cost;
			order.shipping_cost = payload?.shipping_cost;
			if (payload.role_type === 'dropshipper' || payload.role_type === 'admin') {
				order.total_product_price = payload.total_product_price;
			}

			if (payload.role_type === 'supplier' || payload.role_type === 'admin') {
				order.total_base_product_price = payload?.total_base_product_price;
			}

			if (payload.role_type === 'admin') {
				order.seller_name = payload.seller_name;
				order.seller_email = payload.seller_email;
				order.supplier_name = payload.supplier_name;
				order.supplier_id = payload.supplier_id;
				order.supplier_phone = payload.supplier_phone;
			}

			order.payment_info = payload?.payment?.method;
			order.city = payload?.customer_data?.city;
		}
	},
	[SET_DETAIL](state, id) {
		if (id) {
			state.orderDetail = state.privateOrders?.find(curr => curr?._id === id);
		}
	},
	[SET_ALL_DATA](state, payload) {
		state.allPrivateOrders = payload;
	},
	[SET_SELECTED_DATA](state, payload) {
		state.selectedData = payload;
	},
	[ADD_TO_SELECTED](state, orderId) {
		state.selectedData.push(orderId); // Menambahkan orderId ke array
	},
	REMOVE_FROM_SELECTED(state, orderId) {
		state.selectedData = state.selectedData.filter(id => id !== orderId);
	},
};

const actions = {
	setData({ commit }, payload) {
		commit(SET_DATA, payload);
	},
	setAllData({ commit }, payload) {
		commit(SET_ALL_DATA, payload);
	},
	setScoreboard({ commit }, payload) {
		commit(SET_SCOREBOARD, payload);
	},
	concatData({ commit }, payload) {
		commit(CONCAT_DATA, payload);
	},
	updateData({ commit }, payload) {
		commit(UPDATE_DATA, payload);
	},
	setDetailOrder({ commit }, id) {
		commit(SET_DETAIL, id);
	},
	setSelectedData({ commit }, payload) {
		commit(SET_SELECTED_DATA, payload);
	},
	addToSelected({ commit }, payload) {
		commit(ADD_TO_SELECTED, payload);
	},
	removeFromSelected({ commit }, orderId) {
		commit(REMOVE_FROM_SELECTED, orderId);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
